import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Layout from 'components/Layout';
import hasAuthToken from 'lib/hasAuthToken';
import AlphabetLinkList from '@molecules/AlphabetLinkList/AlphabetLinkList';
import Breadcrumbs from 'components/Breadcrumbs';

export const BROWSE_TYPE_EMPLOYERS = 'werkgevers';
export const BROWSE_TYPE_VACANCIES = 'vacatures';
export const BROWSE_TYPE_PLACES = 'plaatsen';
export const BROWSE_TYPES = [
  BROWSE_TYPE_EMPLOYERS,
  BROWSE_TYPE_VACANCIES,
  BROWSE_TYPE_PLACES,
];

function BrowsePage() {
  const { t } = useTranslation();

  return (
    <Layout title={t('browse.pageTitle')}>
      <div className="o-retain o-retain--wall u-margin-top-huge u-margin-bottom-huge">
        <Breadcrumbs
          links={[
            {
              label: t('browse.pageTitle'),
              href: '/bladeren',
            },
          ]}
        />
        <h1 className="u-margin-bottom-base">{t('browse.pageHeading')}</h1>

        <h2 className="h3">Per werkgever</h2>
        <AlphabetLinkList type="werkgevers" />

        <h2 className="h3">Per vacature</h2>
        <AlphabetLinkList type="vacatures" />

        <h2 className="h3">Per plaats</h2>
        <AlphabetLinkList type="plaatsen" />
      </div>
    </Layout>
  );
}

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default BrowsePage;
